'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validation = exports.isValidPhoneNumber = exports.subDomainPattern = exports.numbersAndDotPattern = exports.companyRegistrationNumberPattern = exports.latinLettersOnly = exports.numbersPattern = exports.startWithSpacePattern = exports.whitespacesPattern = exports.lettersDigitsPattern = exports.lettersPattern = exports.numbersAndLettersPattern = exports.alfaNumericPattern = exports.phonePattern = exports.passwordPattern = exports.urlPattern = exports.emailPattern = undefined;

var _libphonenumberJs = require('libphonenumber-js');

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _antd = require('antd');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var emailPattern = exports.emailPattern = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/i;
var urlPattern = exports.urlPattern = /^(http|https):\/\/[.A-Za-z0-9\d-$@$!%*/?&]+\.[A-Za-z\d-$@$!%*/?&]{2,}$/i;
var passwordPattern = exports.passwordPattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)([A-Za-z\u00C0-\u00D6\u00D8-\u00f6\u00f8-\u00ff\s]*)(?=.*[$@$!%#^*?&])[A-Za-z\d$@$#^!%*?&]{8,}$/g;
var phonePattern = exports.phonePattern = /^\+(?:[0-9] ?){6,20}[0-9]$/;
var alfaNumericPattern = exports.alfaNumericPattern = /^[a-z\d\-\s]+$/i;
var numbersAndLettersPattern = exports.numbersAndLettersPattern = /^[0-9a-zA-Z _]+$/;
var lettersPattern = exports.lettersPattern = /^[a-zA-Z]+$/;
var lettersDigitsPattern = exports.lettersDigitsPattern = /^([a-zA-Z0-9]+)([a-zA-Z0-9\-]*)([a-zA-Z0-9]+)$/;
var whitespacesPattern = exports.whitespacesPattern = /^\s|\s\s|\s$/;
var startWithSpacePattern = exports.startWithSpacePattern = /^\s/;
var numbersPattern = exports.numbersPattern = /^\d+$/;
var latinLettersOnly = exports.latinLettersOnly = /^([A-Za-z\u00C0-\u00D6\u00D8-\u00f6\u00f8-\u00ff\s]*)$/g;
var companyRegistrationNumberPattern = exports.companyRegistrationNumberPattern = /^[a-zA-Z0-9#/-]+$/g;
var numbersAndDotPattern = exports.numbersAndDotPattern = /^[0-9.]+$/;
var subDomainPattern = exports.subDomainPattern = /^[a-z\d](?:(?:\-[^-])|(?:[a-z\d]))*$/i;

var isValidPhoneNumber = exports.isValidPhoneNumber = function (phoneNumber) {
  var _ref = (0, _libphonenumberJs.parseNumber)(phoneNumber || '', {
    extended: true
  }),
      possible = _ref.possible;

  return possible;
};

var validation = exports.validation = {
  colorsMatchValidation: function colorsMatchValidation(values, field, message, errors, regex) {
    if (values[field] && regex.test(values[field])) {
      errors[field] = message;
    }

    return errors;
  },
  requiredFieldValidation: function requiredFieldValidation(values, field, message, errors) {
    if (!values[field] && values[field] !== 0) {
      errors[field] = message;
    }

    return errors;
  },
  targetValidation: function targetValidation(values, field, message, errors) {
    if (values[field]) {
      var newRegexp = new RegExp(numbersPattern);

      if (!newRegexp.test(values[field])) {
        errors[field] = message;
      }
    }

    return errors;
  },
  phoneNumberValidation: function phoneNumberValidation(values, field, message, errors) {
    if (values[field]) {
      if (!isValidPhoneNumber(values[field].number)) {
        errors[field] = message;
      }
    }

    return errors;
  },
  paymentAmount: function paymentAmount(values, field, errors) {
    if (!values[field] || values[field] <= 0) {
      errors[field] = 'Field must not be blank and must be greater than 1';
    }

    return errors;
  },
  whitespacesValidation: function whitespacesValidation(value, field, message, errors) {
    if (value[field] && value[field] !== null && value[field].length) {
      if (value[field].trim().length === 0) {
        errors[field] = message;
      }
    }

    return errors;
  },
  pastDateValidation: function pastDateValidation(value, field, message, errors) {
    if ((0, _moment2.default)(value[field]).isBefore((0, _moment2.default)().valueOf())) {
      errors[field] = message;
    }

    return errors;
  },
  comparePasswordValidation: function comparePasswordValidation(value, field, fiedl2, errors) {
    if (value[field] !== value[fiedl2]) {
      errors[fiedl2] = 'Passwords are different';
    }

    return errors;
  },
  lengthValidation: function lengthValidation(value, field, errors, fieldLength) {
    if (value[field] && value[field].length > fieldLength) {
      errors[field] = "Must be ".concat(fieldLength, " characters or less");
    }

    return errors;
  },
  lengthMinValidation: function lengthMinValidation(value, field, errors, fieldLength) {
    if (value[field] && value[field].length < fieldLength) {
      errors[field] = "Must be ".concat(fieldLength, " characters or more");
    }

    return errors;
  },
  exactLengthValidation: function exactLengthValidation(value, field, errors, fieldLength) {
    if (value[field] && value[field].length !== fieldLength) {
      errors[field] = "Must be ".concat(fieldLength, " characters");
    }

    return errors;
  },
  patternValidation: function patternValidation(value, field, pattern, message, errors) {
    var newPattern = new RegExp(pattern);

    if (value[field] && value[field].length && !newPattern.test(value[field])) {
      if (field.toLowerCase().includes('password') && message === null) {
        errors[field] = 'The password should have at least 8 characters in length, 1 lowercase letter, 1 uppercase letter, 1 special character (!@#$%^&*) and 1 number (0–9)';
      } else {
        errors[field] = message;
      }
    }

    return errors;
  },
  minimumInvestmentTicketValidation: function minimumInvestmentTicketValidation(value, field, errors, props) {
    var minimumInvestmentTicket = props.minimumInvestmentByCurrency[value["currency"]];

    if (value[field] && value[field] < minimumInvestmentTicket) {
      errors[field] = "Minimum investment ticket is ".concat(value["currency"], " ").concat(minimumInvestmentTicket);
    }

    return errors;
  },
  minimumInvestmentValidation: function minimumInvestmentValidation(value, field, minimumValue, currency, errors) {
    if (value[field] && value[field] < minimumValue) {
      errors[field] = "Minimum investment is ".concat(currency, " ").concat(minimumValue);
    }

    return errors;
  },
  oddSpacesPattern: function oddSpacesPattern(value, field, message, errors) {
    var newPattern = new RegExp(whitespacesPattern);

    if (newPattern.test(value[field])) {
      errors[field] = message;
    }

    return errors;
  },
  firstSpacesPattern: function firstSpacesPattern(value, field, message, errors) {
    var newPattern = new RegExp(startWithSpacePattern);

    if (newPattern.test(value[field])) {
      errors[field] = message;
    }

    return errors;
  },
  inMinMaxCofines: function inMinMaxCofines(value, field, min, max, message, errors) {
    var numb = Number(value[field]);

    if (numb < min || numb > max) {
      errors[field] = message;
    }

    return errors;
  },
  afterFirstDecimalLimit: function afterFirstDecimalLimit(value, field, limit, message, errors) {
    if (!value[field]) {
      return errors;
    }

    var splitedNumb = value[field].toString().split('.');

    if (splitedNumb[1] && splitedNumb[1].length > limit) {
      errors[field] = message;
    }

    return errors;
  },
  minMaxCountOfSymbol: function minMaxCountOfSymbol(value, field, symbol) {
    var min = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : -Infinity;
    var max = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : Infinity;
    var message = arguments.length > 5 ? arguments[5] : undefined;
    var errors = arguments.length > 6 ? arguments[6] : undefined;

    if (!value[field]) {
      return errors;
    }

    var numb = value[field].split(symbol).length - 1;

    if (numb < min || numb > max) {
      errors[field] = message;
    }

    return errors;
  }
};